import * as ActionTypes from './actionTypes'
import { showToast } from '../../commonComponents/showToast'

//Clear form Action
export const clearForm = () => {
  return {
    type: ActionTypes.CLEAR_FORM,
  }
}
// initialize Items Form
export const initializeItemForm = (payload) => {
  return {
    type: ActionTypes.INITIALIZE_ITEMS_FORM,
    payload,
  }
}

export const updateItemFieldValue=(payload)=> {
  return {
      type: ActionTypes.UPDATE_ITEM_FIELD_VALUE,
      payload
  }
}


export const updateInvoiceHeader = (payload) =>{
  return{
    type: ActionTypes.UPDATE_INVOICE_HEADER,
    payload
  }
}

export const createInvoice=(invoiceId,payload)=>{
  return{
    type:ActionTypes.CREATE_INVOICE,
    invoiceId,
    payload:payload
  }

}
export const deleteInvoice=(invoiceId,payload)=>{
  return {
    type:ActionTypes.DELETE_INVOICE,
    invoiceId,
    payload:payload
  }
}
export const createMechandiseItem=(invoiceId, payload, rest)=>{
  return{
    type:ActionTypes.CREATE_MERCHANDISE_ITEM,
    invoiceId, 
    update:rest,
    payload
  }

}

export const deleteMechandiseItem=(invoiceId,merchandiseId,update)=>{
  return{
    type:ActionTypes.DELETE_MERCHANDISE_ITEM,
    invoiceId,
    merchandiseId,
    update:update
  }

}

export const updateMechandiseItemById=(merchandiseId,payload)=>{
  return{
    type:ActionTypes.UPDATE_MERCHANDISE_ITEM_BY_ID,
    merchandiseId,
    payload
  }

}


export const updateDataAfterSave = (invoiceId,update) =>{

return {
  type:ActionTypes.UPDATE_AFTER_SAVE,
  invoiceId,
  update:update
}

}

 


//containers action

//containers action

export const createContainerItemLevel = (invoiceId, merchandiseId, payload) => {
  return {
    type: ActionTypes.CREATE_ITEM_CONTAINER,
    invoiceId,
    merchandiseId,
    payload,
  }
}

export const deleteContainerItemLevel = (merchandiseId, containerAssociationId) => {
  return {
    type: ActionTypes.DELETE_ITEM_CONTAINER,
    merchandiseId,
    containerAssociationId,
  }
}


// for invoice parties

export const updateItemActorFieldValue =(actorType,payload,invoiceId) => {   

  return {
      type: ActionTypes.UPDATE_ITEM_ACTOR_FIELD_VALUE,
      actorType,
      invoiceId,
      payload
  }
}


export const deleteItemActorField = (actorType,invoiceId) =>{

  return {
    type:ActionTypes.DELETE_ITEM_PARTIES_ACTOR,
    actorType,
    invoiceId
  }

}


export const updateExporterForAllTheInvoices = (invoiceId,payload) =>{
   return{
    type:ActionTypes.UPDATE_EXPORTER_FOR_ALL_INVOICES,
    invoiceId,
    payload,
    actorType:'exporter'
   }
}